/**
* Copyright Aquera Inc 2026
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

export const styles = css`
	:host {
		font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
	}
	.item-header {
		display: flex;
		gap: var(--nile-spacing-xs, var(--ng-spacing-xs));
		width: 100%;
		height: 100%;
		align-items: center;
	}
	.item-header .body-content .header-text {
		display: block;
		font-family: var(--nile-font-family-medium, var(--ng-font-family-body));
		font-weight: var(--nile-font-weight-semibold, var(--ng-font-weight-semibold));
		font-size: var(--nile-type-scale-4, var(--ng-font-size-text-sm));
		line-height: var(--nile-line-height-medium, var(--ng-line-height-text-sm));
		color: var(--nile-colors-dark-500, var(--ng-colors-text-primary-900));
	}
	:host([active]) .item-header .body-content .header-text {
		font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-medium));
		color: var(--nile-colors-primary-700, var(--ng-colors-text-brand-secondary-700));
	}

	:host([disabled]) .item-header .body-content .header-text {
		color: var(--nile-colors-neutral-500, var(--ng-colors-text-disabled));
	}
`;

export default [styles];
